<template>
    <div>
        <div>
            <FileListHeader />
        </div>
        <div v-if="isLoading" class="pt-2 pb-1">
            <FileListItemSkeleton v-for="i in 4" :key="i" mini :rows="3" />
        </div>
        <div v-else>
            <FileListItem
                v-for="v in files"
                :id="v.id"
                :key="v.id"
                classes="py-3"
                :image="v.thumbnail"
                :title="v.name"
                :subheader="v.description"
                :subtitle="v.description"
                :description="v.description"
                :published="v.updatedAt"
                :downloadUrl="v.downloadUrl"
                icon="map-marker-alt"
                subtitle-icon="clock"
            />
        </div>
        <slot />
    </div>
</template>

<script>
import FileListItem from './FileListItem';
import FileListItemSkeleton from './skeletons/FileListItemSkeleton';
import FileListHeader from './FileListHeader';

export default {
    components: { FileListHeader, FileListItem, FileListItemSkeleton },
    props: {
        label: String,
        isLoading: {
            type: Boolean,
            default: false,
        },
        files: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({}),
    methods: {
        goTo() {
            console.log('CLICKED');
        },
    },
};
</script>

<style scoped></style>
